import { render, staticRenderFns } from "./ViewGraphicalForm.vue?vue&type=template&id=390845a7&scoped=true&"
import script from "./ViewGraphicalForm.vue?vue&type=script&lang=js&"
export * from "./ViewGraphicalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390845a7",
  null
  
)

export default component.exports